import { StyleSheet } from "react-native";
import { height, width } from "../../utils/utils";
export const styles = StyleSheet.create({
  viewTextDetail: {
    paddingLeft: 10,
    paddingRight: 29,
    paddingTop: 5,
    paddingBottom: height * 0.03,
  },
  textTitle: {
    fontSize: 22,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginTop: 20,
    width: "100%",
  },
  textDetail: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginTop: 10,
    width: "100%",
  },
  button: {
    width: "30%",
    margin: 19,
  },
  img: {
    maxWidth: "100%",
    width: 473,
    height: 274,
  },
});
export const styles1280 = StyleSheet.create({
  viewTextDetail: {
    paddingLeft: 10,
    paddingRight: 29,
    paddingTop: 5,
    paddingBottom: height * 0.03,
  },
  textTitle: {
    fontSize: 18,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginTop: 20,
    width: "100%",
  },
  textDetail: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginTop: 10,
    width: "100%",
  },
  button: {
    width: "30%",
    margin: 19,
  },
  img: {
    maxWidth: "100%",
    width: 473,
    height: 200,
  },
});
export const stylesResponsive = StyleSheet.create({
  viewTextDetail: {
    paddingLeft: 10,
    paddingRight: 29,
    paddingTop: 5,
    paddingBottom: height * 0.03,
  },
  textTitle: {
    fontSize: 22,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginTop: 20,
    width: "100%",
  },
  textDetail: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginTop: 10,
    width: "100%",
  },
  button: {
    width: width * 0.8,
    margin: 19,
  },
  img: {
    width: width * 0.8,
    height: 200,
  },
});
